import React from 'react';
import { ProductReview } from 'types';
import ReviewSingle from 'components/ReviewSingle';
import ReviewSingleWithFields from 'components/ReviewSingleWithFields';

interface ReviewsProps {
  reviews: ProductReview[];
  canLoadMore?: boolean;
  loadMoreClicked?: () => void;
  customFields?: Array<{ name: string; key: string }>;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & ReviewsProps>;

const Reviews: Props = ({ className, children, reviews, canLoadMore, loadMoreClicked, customFields, ...props }) => {
  return (
    <div {...props} className={`space-y-32 ${className ? className : ''}`}>
      {reviews.map((review, index) =>
        customFields ? (
          <ReviewSingleWithFields key={review.id} review={review} customFields={customFields} />
        ) : (
          <ReviewSingle key={review.id} review={review} />
        ),
      )}

      {canLoadMore && (
        <div className="pt-32">
          <button className="btn-info btn" onClick={loadMoreClicked}>
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default Reviews;
